
/* MAGGIEQUEEN Theme JS */
document.addEventListener('DOMContentLoaded', function() {

  // ── Sticky header ──────────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ── Hero Slider ────────────────────────────────────────
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  let current = 0, timer;

  function goTo(idx) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = (idx + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
  }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(function() { goTo(current + 1); }, 5500);
  }

  if (slides.length > 0) {
    slides[0].classList.add('active');
    if (dots.length > 0) dots[0].classList.add('active');
    startTimer();

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goTo(i); startTimer(); });
    });

    var prev = document.querySelector('.hero-arrow--prev');
    var next = document.querySelector('.hero-arrow--next');
    if (prev) prev.addEventListener('click', function() { goTo(current - 1); startTimer(); });
    if (next) next.addEventListener('click', function() { goTo(current + 1); startTimer(); });
  }

  // ── Mobile Menu ────────────────────────────────────────
  var menuBtn = document.querySelector('.mobile-menu-btn');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function() {
      mobileMenu.classList.toggle('open');
    });
  }

  // ── AI Bot ─────────────────────────────────────────────
  var botBtn = document.querySelector('.ai-bot-btn');
  var botPanel = document.querySelector('.ai-bot-panel');
  var botClose = document.querySelector('.ai-bot-close');
  var botInput = document.querySelector('.ai-bot-input');
  var botSend = document.querySelector('.ai-bot-send');
  var botMessages = document.querySelector('.ai-bot-messages');

  var botResponses = {
    'track': 'Please log in to your account to track your order. Go to My Account → Orders for real-time tracking.',
    'return': 'We offer a 30-day return policy. Items must be unused and in original packaging. Start a return from My Account → Orders.',
    'reward': 'MQ REWARD has 3 tiers: Pearl (free), Gold ($1,000+), Platinum ($300+). Earn points on every purchase!',
    'shipping': 'Free shipping on orders over $300. Standard: 5-10 business days. Express available at checkout.',
    'b2b': 'For wholesale inquiries, please fill out our B2B Inquiry form. Our team responds within 24-48 hours.',
    'hello': 'Hello! I\'m MQ Concierge, your personal MAGGIEQUEEN assistant. How can I help you today? ✨',
    'hi': 'Hi there! Welcome to MAGGIEQUEEN. How can I assist you today?',
  };

  function addMessage(text, role) {
    if (!botMessages) return;
    var msg = document.createElement('div');
    msg.className = 'chat-msg chat-msg--' + role;
    msg.textContent = text;
    botMessages.appendChild(msg);
    botMessages.scrollTop = botMessages.scrollHeight;
  }

  function getBotReply(input) {
    var lower = input.toLowerCase();
    for (var key in botResponses) {
      if (lower.includes(key)) return botResponses[key];
    }
    return 'Thank you for your message! Our team will get back to you within 24 hours. Is there anything else I can help with?';
  }

  function sendMessage() {
    if (!botInput || !botInput.value.trim()) return;
    var text = botInput.value.trim();
    addMessage(text, 'user');
    botInput.value = '';
    setTimeout(function() { addMessage(getBotReply(text), 'bot'); }, 1000);
  }

  if (botBtn && botPanel) {
    botBtn.addEventListener('click', function() {
      botPanel.classList.toggle('open');
    });
  }
  if (botClose) {
    botClose.addEventListener('click', function() {
      botPanel.classList.remove('open');
    });
  }
  if (botSend) botSend.addEventListener('click', sendMessage);
  if (botInput) {
    botInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') sendMessage();
    });
  }

  // ── Shipping Progress Bar ──────────────────────────────
  var fill = document.querySelector('.shipping-progress-fill');
  var label = document.querySelector('.shipping-progress-label');
  if (fill) {
    var cart = window.Shopify && window.Shopify.cart ? window.Shopify.cart.total_price / 100 : 0;
    var threshold = 300;
    var pct = Math.min((cart / threshold) * 100, 100);
    fill.style.width = pct + '%';
    if (label) {
      if (pct >= 100) {
        label.textContent = '🎉 You\'ve unlocked FREE shipping!';
      } else {
        label.textContent = 'Add $' + (threshold - cart).toFixed(2) + ' more for FREE shipping';
      }
    }
  }

  // ── Scroll reveal ──────────────────────────────────────
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function(el) { obs.observe(el); });
  } else {
    reveals.forEach(function(el) { el.classList.add('revealed'); });
  }

});
